import StoreApplicationState from "@store/Store/StoreApplicationState";
import { RmaAttachedFileModel } from "@store/Types/ApiModels";

export const getRmaLinesRaw = (state: StoreApplicationState) => state.store.data.rmaRequest.rmaLineModels;
export const getRmaNotes = (state: StoreApplicationState) => state.store.data.rmaRequest.rmaNotes;
export const getRmaReasons = (state: StoreApplicationState) => state.store.data.rmaReasons.rmaReasons;

export const getRmaProductInfos = (state: StoreApplicationState) => state.store.pages.rma.productInfos;

export const getRmaAttachedFiles = (state: StoreApplicationState) => state.store.data.rmaRequest.rmaAttachedFiles;
export const getRmaTotalFilesSize = (state: StoreApplicationState) =>
    getRmaAttachedFiles(state).reduce((acc: number, file: RmaAttachedFileModel) => acc + file.Size, 0);
